import React from "react";
import { motion } from "framer-motion";


const Backdrop = ({ children, onClick }) => {

    return (
        <motion.div className='absolute'>
            <motion.div
                className='fixed top-0 left-0 h-full w-full bg-black/50 grid items-center px-4 justify-center'
                onClick={onClick}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}

            >
                {children}

            </motion.div>
        </motion.div>
    )
}

export default Backdrop;